/* E__PRESCRIBER_SIGNUP__V1 — máscaras de WhatsApp, CEP e CPF */
(() => {
  const formatters = {
    cpf(digits) {
      const value = digits.slice(0, 11);
      return value
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
    },
    phone(digits) {
      const value = digits.slice(0, 11);
      if (value.length <= 2) return value.length ? `(${value}` : '';
      const splitAt = value.length > 10 ? 7 : 6;
      const prefix = `(${value.slice(0, 2)}) ${value.slice(2, splitAt)}`;
      return value.length > splitAt ? `${prefix}-${value.slice(splitAt)}` : prefix;
    },
    zip(digits) {
      const value = digits.slice(0, 8);
      return value.length > 5 ? `${value.slice(0, 5)}-${value.slice(5)}` : value;
    },
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest('.tp-e-prescriber-signup [data-mask]');
    if (!input) return;

    const format = formatters[input.dataset.mask];
    if (format) input.value = format(input.value.replace(/\D/g, ''));
  });
})();
